import React, { useEffect, useRef, useState } from 'react';
import * as PropTypes from 'prop-types';
import { Button, Col, Row } from 'react-bootstrap';
import { Form, Formik } from 'formik';
import {
  FormDatePickerField,
  FormInputField,
  FormSelectField,
} from '../../common/components/formFields';
import DealersSelectField from '../../dealers/forms/DealersSelectField';
import LocationsSelectField from '../../locations/forms/LocationsSelectField';
import ComponentCard from '../../common/components/cards/ComponentCard';

const initialValues = {
  invoiceNumber: '',
  organizationId: '',
  organizationLocationId: '',
  status: '',
  amountInPenceFrom: '',
  amountInPenceTo: '',
  invoiceDateFrom: '',
  invoiceDateTo: '',
};

const statusOptions = [
  { value: 'PAID', label: 'Paid' },
  { value: 'UNPAID', label: 'Unpaid' },
  { value: 'REFUNDED', label: 'Refunded' },
];

function InvoicesSearch({ onSearch, dealerName, dealerOrganizationId }) {
  const formRef = useRef();
  const [reloadDatePickerKey, setReloadDatePickerKey] = useState(false);

  useEffect(() => {
    if (dealerName && dealerOrganizationId && formRef.current) {
      const dealerOption = { value: dealerOrganizationId, label: dealerName };
      formRef.current.setFieldValue('organizationId', dealerOption);
    }
  }, [dealerName, dealerOrganizationId]);

  const handleClearButtonClick = (resetForm, submitForm) => {
    setReloadDatePickerKey((prevState) => !prevState);
    resetForm();

    if (dealerName && dealerOrganizationId && formRef.current) {
      const dealerOption = { value: dealerOrganizationId, label: dealerName };
      formRef.current.setFieldValue('organizationId', dealerOption);
    }

    submitForm();
  };

  return (
    <ComponentCard title="Search Invoices" isCollapsible>
      <Formik
        innerRef={formRef}
        initialValues={initialValues}
        onSubmit={onSearch}
        validateOnBlur
      >
        {({ values, resetForm, submitForm, setFieldValue }) => (
          <Form noValidate className="search-form-compact">
            <Row>
              <Col lg="4">
                <FormInputField name="invoiceNumber" label="Invoice Number" />
              </Col>
              <Col lg="4">
                <DealersSelectField
                  name="organizationId"
                  label="Dealer"
                  disabled={!!dealerName}
                  onChangeHandler={() => setFieldValue('organizationLocationId', null)}
                />
              </Col>
              <Col lg="4">
                <LocationsSelectField
                  name="organizationLocationId"
                  label="Location"
                  organizationId={values.organizationId?.value || null}
                  disabled={!values.organizationId?.value}
                />
              </Col>
            </Row>
            <Row>
              <Col lg="4">
                <FormSelectField name="status" label="Status" options={statusOptions} />
              </Col>
              <Col lg="4">
                <FormInputField name="amountInPenceFrom" label="Amount From" type="number" />
              </Col>
              <Col lg="4">
                <FormInputField name="amountInPenceTo" label="Amount To" type="number" />
              </Col>
              <Col lg="4">
                <FormDatePickerField
                  name="invoiceDateFrom"
                  label="Invoice Date From"
                  key={reloadDatePickerKey}
                />
              </Col>
              <Col lg="4">
                <FormDatePickerField
                  name="invoiceDateTo"
                  label="Invoice Date To"
                  key={reloadDatePickerKey}
                  isUpperRange
                />
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <Button className="mt-4 float-end ms-2 rounded-pill btn-primary" type="submit">
                  Search
                </Button>
                <Button
                  className="mt-4 float-end rounded-pill btn-soft-primary"
                  type="button"
                  onClick={() => handleClearButtonClick(resetForm, submitForm)}
                >
                  Clear
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </ComponentCard>
  );
}

InvoicesSearch.propTypes = {
  onSearch: PropTypes.func.isRequired,
  dealerName: PropTypes.string,
  dealerOrganizationId: PropTypes.string,
};

InvoicesSearch.defaultProps = {
  dealerName: null,
  dealerOrganizationId: null,
};

export default InvoicesSearch;
